import {
  AppDatePicker,
  AppInput,
  AppRemixIcon,
  AppSingleSelect,
} from '@/layout/AppComponents';
import ReactDOMServer from 'react-dom/server';
import BtnOptions from './BtnOptions';
import Translator from '../../../../components/helpers/Translator';

export default function Report59Options({
  handleOnSetFieldValue,
  handleOnSubmit,
  handleOnSave,
  values,
}) {
  return (
    <>
      <div className="row">
        <div className="col-lg-6">
          <AppDatePicker
            title={ReactDOMServer.renderToString(
              <Translator file="module-intelligence" name="module.int.from" />
            )}
            value={values.from}
            placeholder="mm/yyyy"
            onChange={(date) => handleOnSetFieldValue('from', date)}
            popperClassName="react-datepicker-popper react-datepicker-popper-1000"
            isClearable
            showYearDropdown
            dateFormatCalendar="MMMM"
            yearDropdownItemNumber={100}
            scrollableYearDropdown
            hasToggleType
            calendarStartDay={1}
          />
        </div>
        <div className="col-lg-6">
          <AppDatePicker
            title={ReactDOMServer.renderToString(
              <Translator file="module-intelligence" name="module.int.to" />
            )}
            value={values.to}
            placeholder="dd/mm/yyyy"
            onChange={(date) => handleOnSetFieldValue('to', date)}
            popperClassName="react-datepicker-popper react-datepicker-popper-1000"
            isClearable
            showYearDropdown
            dateFormatCalendar="MMMM"
            yearDropdownItemNumber={100}
            scrollableYearDropdown
            hasToggleType
            calendarStartDay={1}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12">
          <AppInput
            icon={<AppRemixIcon icon="fingerprint" />}
            title={ReactDOMServer.renderToString(
              <Translator file="module-intelligence" name="obligations" />
            )}
            placeholder={ReactDOMServer.renderToString(
              <Translator
                file="module-intelligence"
                name="module.int.obligations-separated-commas"
              />
            )}
            value={values?.obligations ?? ''}
            onChange={(value) => handleOnSetFieldValue('obligations', value)}
            isClearable
          />
        </div>
        <div className="col-lg-6">
          <AppSingleSelect
            icon={<AppRemixIcon icon="refresh" />}
            options={[
              {
                value: true,
                label: 'ID',
              },
              {
                value: false,
                label: 'CODE',
              },
            ]}
            title={ReactDOMServer.renderToString(
              <Translator
                file="module-intelligence"
                name="module.int.search-type"
              />
            )}
            value={values?.isId}
            onChange={(date) => handleOnSetFieldValue('isId', date)}
            isClearable
          />
        </div>
        <div className="col-lg-6">
          <AppSingleSelect
            icon={<AppRemixIcon icon="refresh" />}
            options={[
              {
                value: 0,
                label: ReactDOMServer.renderToString(
                  <Translator
                    file="module-intelligence"
                    name="module.int.only-last-one"
                  />
                ),
              },
              {
                value: 1,
                label: ReactDOMServer.renderToString(
                  <Translator
                    file="module-intelligence"
                    name="module.int.all"
                  />
                ),
              },
            ]}
            title={ReactDOMServer.renderToString(
              <Translator
                file="module-intelligence"
                name="module.int.evidence-presented"
              />
            )}
            value={values?.showAll}
            onChange={(date) => handleOnSetFieldValue('showAll', date)}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <BtnOptions
            isDisabled={
              !values.obligations || values.showAll === undefined || values.isId === undefined
            }
            handleOnSave={() => handleOnSave(true)}
            handleOnSubmit={() => handleOnSubmit()}
          />
        </div>
      </div>
    </>
  );
}
